export enum LocationSearchModeEnum {
	Strict = 'strict',
	General = 'general',
	Auto = 'auto',
}
